import './PropertyCard.scss';
import { Link } from 'react-router-dom';
import { formatMoney } from '../../shared/utility';
import { BathtubIcon, BedIcon } from '../../assets/icons';

const PropertyCard = ({ id, name, cardPicURL, location, unit, currency }) => {
  return (
    <Link className="card" to={`/discover/${id}`}>
      <div className="card__img-container">
        <img src={cardPicURL} alt="property img" />
      </div>
      <p className="price">
        {!currency
          ? formatMoney(unit.price)
          : formatMoney(unit.price, currency)}
      </p>
      <h4>{name.length > 10 ? `${name.substring(0, 10)}...` : name}</h4>
      <div className="card__details">
        <p>
          <span>{location.city}</span>, <span>{location.country}</span>
        </p>
        <div className="card__details--imgs">
          <div className="bed">
            <BedIcon />
            <span>{unit.beds}</span>
          </div>
          <div className="bathtub">
            <BathtubIcon />
            <span>{unit.baths}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PropertyCard;
